import React from 'react';

type TrendingRoundIconProps = React.SVGProps<SVGSVGElement>;

export const TrendingRoundIcon: React.FC<TrendingRoundIconProps> = (props) => (
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}>
    <rect x="4" y="4" width="48" height="48" rx="24" fill="#F6EFFF" />
    <rect x="4" y="4" width="48" height="48" rx="24" stroke="#F9F5FF" strokeWidth="8" />
    <path
      d="M39 22L29.5 31.5L24.5 26.5L17 34M39 22H33M39 22V28"
      stroke="#6941C6"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

TrendingRoundIcon.displayName = 'TrendingRoundIcon';

export default TrendingRoundIcon;
